import {v4 as uuidV4} from 'uuid'
import * as nanoid from 'nanoid'

export const v4 = uuidV4
export const generateBDDID = nanoid.customAlphabet('0123456789', 10)
